import { tooluploadInitialState, TooluploadState } from '../se-toolupload/redux/toolupload.state';
import { connectivityInitialState, ConnectivityState } from '../connectivity/connectivity.store';
import { EnvironmentState, environmentInitialState } from '../environment/environment.state';
import { pdfModalInitialState, PdfModalState } from '../pdf-modal/redux/pdf-modal.state';
import { seReportInitialState, SeReportState } from '../report/report.state';
import { ExternalDocsState, externalDocsInitialState } from '../se-external-docs/redux/external-docs.state';
import { SeSideNavComponentState, seSideNavComponentInitialState } from '../se-side/redux/se-side-nav.state';
import {
    SeButtonsToolbarState,
    seButtonsToolbarInitialState,
} from '../se-toolbar/se-buttons-toolbar/redux/se-buttons-toolbar.state';
import {
    HeaderToolbarState,
    seHeaderToolbarInitialState,
} from '../se-toolbar/se-header-toolbar/se-header-toolbar.state';
import { SearchPageState, searchPageInitialState } from '../search-page/redux/search-page.state';
import { seSignInitialState, SeSignState } from '../sign/estensasign.state';
import { seStepperSideNavParentInitialState, SeStepperSideNavParentState } from "../se-stepper-side-nav/redux/se-stepper-side-nav.state";

export interface RootState {
    buttonsToolbar: SeButtonsToolbarState;
    connectivity: ConnectivityState;
    environment: EnvironmentState;
    externalDocs: ExternalDocsState;
    headerToolbar: HeaderToolbarState;
    pdfModal: PdfModalState;
    report: SeReportState;
    searchPage: SearchPageState;
    seSideNav: SeSideNavComponentState;
    sign: SeSignState;
    toolVna: TooluploadState;
    seStepperSideNav: SeStepperSideNavParentState;
}

export const initialRootState: RootState = {
    buttonsToolbar: seButtonsToolbarInitialState,
    connectivity: connectivityInitialState,
    environment: environmentInitialState,
    externalDocs: externalDocsInitialState,
    headerToolbar: seHeaderToolbarInitialState,
    report: seReportInitialState,
    pdfModal: pdfModalInitialState,
    searchPage: searchPageInitialState,
    seSideNav: seSideNavComponentInitialState,
    sign: seSignInitialState,
    toolVna: tooluploadInitialState,
    seStepperSideNav: seStepperSideNavParentInitialState
};
